// extracted by mini-css-extract-plugin
export default {"root":"OfferModal_root__J3rcc","dialog":"OfferModal_dialog__ZxMju"};